import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents'
import { formatDuration } from '@utils/utils-format'

export function useExperienceRegistrationDeadline(experience: NexperienceFragment) {
  if (experience.registrationDeadline === 0) {
    return 'Bis Terminbeginn'
  }

  if (experience.registrationDeadline < 60) {
    return `Bis ${formatDuration({
      minutes: experience.registrationDeadline,
    })} vor Terminbeginn`
  }

  if (experience.registrationDeadline / 60 < 24) {
    const hours = Math.floor(experience.registrationDeadline / 60)

    return `Bis ${formatDuration({
      hours,
    })} vor Terminbeginn`
  }

  const days = Math.floor(experience.registrationDeadline / 24 / 60)

  return `Bis ${formatDuration({
    days,
  })} vor Terminbeginn`
}
